import styled from 'styled-components';

interface WizardTitleProp {
  marginBotton?: number;
}

const WizardTitle = styled.span`
  font-weight: 600;
  margin-bottom: ${(prop: WizardTitleProp) => (prop.marginBotton ? prop.marginBotton + 'px' : '8px')};
  max-width: 300px;
  text-align: center;
  font-size: 1.5rem;
  margin-top: 8px;
`;

export { WizardTitle };
